import { DropShip } from '../constants/features';
import { useIsSellerFeatureEnabled } from './use-is-seller-feature-enabled';

export const useIsDropShipEnabledForSeller = () => {
  return useIsSellerFeatureEnabled(DropShip);
};
